export enum ResourceSection {
  DOCUMENTATION = 'documentation',
  PARTNERS = 'partners',
  TRAINING = 'training',
}
